import React from 'react'
import { Box, useTheme } from '@mui/material'
import GenericButton from '../../../../components/GenericButton'
import { grey } from '../../../../colors'
import { type KeyStatType } from '../constants'

interface StatButton {
  label: string
  value: KeyStatType
}

interface StatButtonGroupProps {
  buttons: StatButton[]
  selected: KeyStatType
  onSelect: React.Dispatch<React.SetStateAction<string>>
  sx?: object
  buttonSx?: object
}

const StatButtonGroup: React.FC<StatButtonGroupProps> = ({
  buttons,
  selected,
  onSelect,
  sx = {},
  buttonSx = {}
}) => {
  const theme = useTheme()
  return (
    <Box sx={{ display: 'flex', border: `1px solid ${grey[350]}`, borderRadius: '4px', overflow: 'hidden', ...sx }}>
      {buttons.map((btn, idx) => {
        const isLast = idx === buttons.length - 1
        const isSelected = selected === btn.value
        return (
          <GenericButton
            label={btn.label}
            key={btn.value}
            onClick={() => { onSelect(btn.value) }}
            sx={{
              padding: theme.spacing(1.5, 4),
              borderRight: isLast ? 'none' : `1px solid ${grey[350]}`,
              fontWeight: 500,
              background: isSelected ? `${grey[100]} !important` : `${grey[0]} !important`,
              color: grey[900],
              borderRadius: 'unset',
              transition: 'background 0.2s',
              '&:hover': {
                background: isSelected ? `${grey[0]} !important` : `${grey[100]} !important`
              },
              ...buttonSx
            }}
          />
        )
      })}
    </Box>
  )
}

export default StatButtonGroup
